/*
 * Smooth scrolling for WLS in-page anchor buttons (a.wls-btn[href^="#"]).
 *
 * Safari / iOS ignore CSS `scroll-behavior: smooth` for anchor jumps (it only
 * landed in Safari 15.4 and is still unreliable), so those browsers snap
 * instantly. This script animates the scroll itself with requestAnimationFrame,
 * giving the same smooth motion on every browser regardless of CSS support.
 */
(function () {
  if (window.wlsSmoothScrollInit) return;
  window.wlsSmoothScrollInit = true;

  var DURATION = 600; // ms
  var EXTRA_OFFSET = 8; // px of breathing room below the sticky bar(s)

  // Sticky top bars whose height overlaps the scroll target and would hide its
  // top (e.g. the buybox label on mobile, where the section has no top padding).
  var STICKY_BAR_SELECTORS = '.wls-promobar.is-sticky-promobar, .wls-header.is-sticky-header';

  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function getStickyOffset() {
    var offset = 0;
    document.querySelectorAll(STICKY_BAR_SELECTORS).forEach(function (bar) {
      offset += bar.getBoundingClientRect().height;
    });
    return offset;
  }

  function animateScroll(targetY) {
    var root = document.documentElement;
    var previousBehavior = root.style.scrollBehavior;
    // Disable CSS smooth scroll so per-frame scrollTo() jumps are instant and
    // don't fight our own animation (mainly on Chrome).
    root.style.scrollBehavior = 'auto';

    var startY = window.pageYOffset || root.scrollTop;
    var distance = targetY - startY;
    var start;

    function step(timestamp) {
      if (start === undefined) start = timestamp;
      var progress = Math.min((timestamp - start) / DURATION, 1);
      window.scrollTo(0, startY + distance * easeInOutQuad(progress));

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        root.style.scrollBehavior = previousBehavior;
      }
    }

    requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.wls-btn[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (!hash || hash === '#') return;

    var target = document.getElementById(hash.slice(1));
    if (!target) return;

    event.preventDefault();

    var currentY = window.pageYOffset || document.documentElement.scrollTop;
    var targetY = target.getBoundingClientRect().top + currentY - getStickyOffset() - EXTRA_OFFSET;
    animateScroll(Math.max(targetY, 0));

    // Keep the URL hash in sync (native anchor behaviour) without an extra jump.
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', hash);
    }
  });
})();
